import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister, } from '@lexical/utils';
import { COMMAND_PRIORITY_CRITICAL, SELECTION_CHANGE_COMMAND } from 'lexical';
import * as React from 'react';
import { useEffect, useState } from 'react';
import DialogStyled from "../../components/dialogStyled";
import IconFontAwesome from "../../components/iconFontAwesome";
import { INSERT_HORIZONTAL_RULE_COMMAND } from "../nodes/horizontalRuleNode";
import DropDown, { DropDownItem } from '../ui/DropDown';
import { InsertInlineImageDialog } from "./InlineImagePlugin";

export default function ToolbarInsertPlugin(): JSX.Element {
	const [editor] = useLexicalComposerContext();
	const [activeEditor, setActiveEditor] = useState(editor);
	const [isModalImageOpen, setIsModalImageOpen] = useState(false);
	const [isEditable, setIsEditable] = useState(() => editor.isEditable());

	useEffect(() => {
		return editor.registerCommand(
			SELECTION_CHANGE_COMMAND,
			(_payload, newEditor) => {
				setActiveEditor(newEditor);
				return false;
			},
			COMMAND_PRIORITY_CRITICAL,
		);
	}, [editor]);

	useEffect(() => {
		return mergeRegister(
			editor.registerEditableListener((editable) => {
				setIsEditable(editable);
			}),
		);
	}, [activeEditor, editor]);

	return (
		<div className="toolbar !pr-0 !flex-grow-0">
			<DropDown
				disabled={!isEditable}
				buttonClassName="toolbar-item spaced"
				buttonLabel="Insert"
				buttonAriaLabel="Insert specialized editor node"
				buttonIconFontAwesomeClassName="icon-plus mr-2"
			>
				<DropDownItem
					onClick={() => setIsModalImageOpen(true)}
					className="item">
					<IconFontAwesome className="icon-image mr-2"/>
					<span className="text">Image</span>
				</DropDownItem>

				<DropDownItem
					onClick={() => {
						activeEditor.dispatchCommand(
							INSERT_HORIZONTAL_RULE_COMMAND,
							undefined,
						);
					}}
					className="item">
					<IconFontAwesome className="icon-grip-lines mr-2"/>
					<span className="text">Horizontal Rule</span>
				</DropDownItem>
			</DropDown>

			<DialogStyled
				isOpen={isModalImageOpen}
				onClose={() => setIsModalImageOpen(false)}
				classesSize={"max-w-[90vw] max-h-[97vh]"}
			>
				<InsertInlineImageDialog
					activeEditor={activeEditor}
					onClose={() => setIsModalImageOpen(false)}
				/>
			</DialogStyled>
		</div>
	);
}
